
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";

    import DatePicker from "@/vue/components/DatePicker.vue";
    import PrintTextBox from "@/vue/components/PrintForm/PrintTextBox.vue";
    import PrintTextArea from "@/vue/components/PrintForm/PrintTextArea.vue";
    import PrintCheckbox from "@/vue/components/PrintForm/PrintCheckbox.vue";
    import PrintDatePicker from "@/vue/components/PrintForm/PrintDatePicker.vue";
    import PrintDateTimePicker from "@/vue/components/PrintForm/PrintDateTimePicker.vue";
    import PrintSelect from "@/vue/components/PrintForm/PrintSelect.vue";

    import { Site } from "@/model/Site";
    import { WorkPermit } from "@/model/workPermits/WorkPermit";

    @Component({
        components: {
            DatePicker,
            PrintDatePicker,
            PrintDateTimePicker,
            PrintTextBox,
            PrintTextArea,
            PrintCheckbox,
            PrintSelect
        }
    })
    export default class SwmScapaBeforePart extends Vue {

        @Prop({ required: true }) site!: Site;
        @Prop({ required: true }) workPermit!: WorkPermit;
        @Prop({ default: false }) isReadOnly!: boolean;
        @Prop({ default: false }) isReadOnlyExceptReIssue!: boolean;
        @Prop({ default: ({}) }) pulseRedClass!: any;

        minimumFromDate = new Date(new Date().setHours(0, 0, 0, 0));

        get minimumToDate(): Date {
            return this.minimumFromDate < this.workPermit.validFrom
            ? this.workPermit.validFrom
            : this.minimumFromDate;
        }
    }

